import { CRMAPIBase } from "@api/crmApiBase";
import { ScheduleTemplateResp } from "@api/responseModels/worker/schedule/scheduleTemplateResponse";
import { TScheduleTemplate } from "@components/schedule/common/types";

class ScheduleTemplateGroup extends CRMAPIBase {
    async saveScheduleTemplate(
        template: TScheduleTemplate
    ) {
        const result = await this.post<ScheduleTemplateResp>('/schedule-templates', {
            ...template
        });
        return result;
    }

    async getScheduleTemplate(
        crm_id: number,
        id: number
    ) {
        const result = await this.get<ScheduleTemplateResp>(`/schedule-templates/${id}`, {
            crm_id
        });
        return result;
    }

    async getScheduleTemplateList(crm_id: number, page = 1) {
        const result = await this.get<ScheduleTemplateResp>('/schedule-templates', {
            crm_id,
            filters: {
                deleted: 'null'
            },
            page,
            per_page: 5,
        });
        return result;
    }

    async updateScheduleTemplate(
        template: TScheduleTemplate
    ) {
        const result = await this.put<ScheduleTemplateResp>(`/schedule-templates/${template.id}`, {
            ...template
        });
        return result;
    }

    async removeScheduleTemplate(crm_id: number, id: number) {
        const result = await this.delete<ScheduleTemplateResp>(`/schedule-templates/${id}`, {
            crm_id
        });
        return result;
    }

    async restoreScheduleTemplate(crm_id: number, id: number) {
        const result = await this.post<ScheduleTemplateResp>(`/schedule-templates/${id}/restore`, {
            crm_id
        });
        return result;
    }
}

export { ScheduleTemplateGroup };